import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Dropdown } from '@blueprint/ui';

const getRems = (pixels: number) => `${+pixels / 16}rem`;

export const SearchResultsHeaderWrapper = styled.div(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing['24px']};
        display: block;
        margin-top: -${theme.spacing['24px']};

        h1 {
            margin-bottom: ${theme.spacing['16px']};
            font-weight: ${theme.type.semiBold};
            font-size: ${theme.fontSizes[9]};
        }

        ${theme.mq.medium} {
            margin-top: 0;
        }

        ${theme.mq.large} {
            margin-bottom: ${theme.spacing['32px']};

            h1 {
                margin-bottom: ${theme.spacing['24px']} 0;
                font-size: ${theme.fontSizes[7]};
            }
        }

        @media only screen and (min-width: 1140px) {
            padding-right: ${theme.spacing['32px']};
        }
    `
);

export const SearchResultsTotalText = styled('p')(
    ({ theme }) => css`
        margin: auto 0;
        line-height: ${theme.type.lineHeight};
        font-size: ${theme.type.body};
        color: ${theme.colors['text-body']};
        font-weight: ${theme.type.semiBold};
    `
);

export const Footer = styled.div(
    ({ theme }) => css`
        display: block;

        ${theme.mq.small} {
            display: flex;
            width: 100%;
        }
    `
);

export const SortOrderDropdownStyle = styled(Dropdown)(
    ({ theme }) => css`
        ${theme.mq.small} {
            width: ${getRems(180)};
        }

        ${theme.mq.large} {
            margin-left: ${theme.spacing['32px']};
        }
    `
);

export const FooterCell = styled.div(
    ({ theme }) => css`
        flex-grow: 1;
        display: flex;
        height: ${getRems(54)};

        > * {
            margin-top: auto;
            margin-bottom: auto;
        }

        &:first-of-type {
            display: flex;
            justify-content: space-between;
            margin-bottom: ${theme.spacing['24px']};
            margin-bottom: 0;

            ${theme.mq.small} {
                justify-content: flex-start;
            }
        }

        &:last-of-type {
            justify-content: flex-end;
            display: none;

            ${theme.mq.large} {
                display: flex;
            }
        }
    `
);

export const Divider = styled('span')(
    ({ theme }) => css`
        width: 0.0625rem;
        height: 1.375rem;
        background-color: ${theme.colors['graphic-divider']};
        display: none;
        margin: 0 ${theme.spacing['24px']} 0 ${theme.spacing['16px']};
        align-self: center;
        display: inline-block;
    `
);

// --- AB Test Styles ---
export const StyledFooter = styled('div')(
    ({ theme: { spacing, mq } }) => css`
        display: flex;
        flex-direction: column;
        row-gap: ${spacing['16px']};

        ${mq.small} {
            flex-direction: row;
            justify-content: space-between;
        }
    `
);

export const StyledFooterCell = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        align-items: center;
        column-gap: ${spacing['16px']};
        justify-content: space-evenly;
    `
);

export const StyledDivider = styled('div')(
    ({ theme: { colors } }) => css`
        width: 0.0625rem;
        flex-basis: 0.0625rem;
        height: 2rem;
        background-color: ${colors['graphic-divider']};
        display: inline-block;
    `
);
